import axios from "axios";
import { LOGOUT } from "@/store/auth/types";
import { SET_SERVER_ERROR } from "@/store/service/types";
import { PRIVATE_ROUTES } from "@/router";

export default {
  setupInterceptors: (store, router) => {
    // Add a response interceptor
    axios.interceptors.response.use(
      response => {
        if (store.state.service.hasError) {
          store.commit(
            {
              type: `service/${SET_SERVER_ERROR}`,
              payload: false
            },
            { root: true }
          );
        }

        // if (response.data && response.data.plan_level && response.data.plan_level.String === "trial") {
        //   router.replace("/payment");
        // }

        return response;
      },
      error => {
        //for zendesk
        if (!error.response) {
          return Promise.reject(error);

          // Catches if user don't have token
        } else {
          if (error.response.status === 401) {
            if (PRIVATE_ROUTES.includes(router.currentRoute.name)) {
              store.commit(
                {
                  type: `auth/${LOGOUT.success}`
                },
                { root: true }
              );
              router.replace("/login");
            }
          }

          if (error.response.status === 500) {
            // router.replace("/500");
          }

          return Promise.reject(error);
        }
      }
    );
  }
};
